import { render, staticRenderFns } from "./PurchaseItemView.view.vue?vue&type=template&id=2d2c3097&"
import script from "./PurchaseItemView.view.vue?vue&type=script&lang=js&"
export * from "./PurchaseItemView.view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/stage-dev1/front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2d2c3097')) {
      api.createRecord('2d2c3097', component.options)
    } else {
      api.reload('2d2c3097', component.options)
    }
    module.hot.accept("./PurchaseItemView.view.vue?vue&type=template&id=2d2c3097&", function () {
      api.rerender('2d2c3097', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/rearchitected/themes/atmo/views/pages/purchases/item/view/PurchaseItemView.view.vue"
export default component.exports